/** Infer Reactable filter controls when pages omit filterType. */

const DATE_ACCESSOR =
    /(^date$|_date$|_on$|^published_date$|^registered_date$|^due_date$|^date_of_|^created_at$|^updated_at$|^start_date$|^end_date$|^expected_end_date$|^opened_on$|^closed_on$|^payroll_date$|_at$)/i;

export const ATTENDANCE_STATUS_FILTER_OPTIONS = [
    { value: "present", label: "Present" },
    { value: "absent", label: "Absent" },
    { value: "TP", label: "Transferred Present" },
    { value: "TA", label: "Transferred Absent" },
    { value: "holiday", label: "Holiday" },
    { value: "on-duty", label: "On Duty" },
    { value: "week-off", label: "Week Off" },
    { value: "compensation", label: "Compensation" },
    { value: "WFH", label: "WFH" },
    { value: "leave", label: "Leave" },
];

export const NOTICE_STATUS_FILTER_OPTIONS = [
    { value: "Published", label: "Published" },
    { value: "Scheduled", label: "Scheduled" },
    { value: "Draft", label: "Draft" },
];

export function enrichFilterableColumn(column) {
    if (!column?.filterable || column.filterType) {
        return column;
    }
    const acc = typeof column.accessor === "string" ? column.accessor : "";
    if (!acc) {
        return column;
    }

    if (DATE_ACCESSOR.test(acc)) {
        return { ...column, filterType: "date" };
    }

    if (acc === "status" && !column.filterOptions?.length) {
        if (column.statusFilterPreset === "attendance") {
            return {
                ...column,
                filterType: "select",
                filterOptions: ATTENDANCE_STATUS_FILTER_OPTIONS,
            };
        }
        if (column.statusFilterPreset === "notice") {
            return {
                ...column,
                filterType: "select",
                filterOptions: NOTICE_STATUS_FILTER_OPTIONS,
            };
        }
    }

    if ((acc === "branch" || acc === "branch_name") && column.filterOptions?.length) {
        return { ...column, filterType: "select" };
    }

    return column;
}

export function enrichFilterableColumns(columns) {
    return (columns || []).map(enrichFilterableColumn);
}
